__turbopack_context__.v({
  "className": "noto_sans_thai_7b9e7099-module__12Gf9G__className",
});
